import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICtoContract } from '../../../core/models/cto.model';
import { DialogComponent } from '../../../shared/components/modals/dialog/dialog.component';
import { ModalService } from '../../../core/modal/modal.service';
import { PageHeaderDropdownItem } from '../../../shared/page-header/page-header.model';
import {CtoApiService} from "../../../core/modules/cto/cto-api.service";

@Component({
  selector: 'tax-cto-detail-header',
  templateUrl: './cto-detail-header.component.html',
  styleUrls: ['./cto-detail-header.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoDetailHeaderComponent implements OnChanges, OnDestroy {
  // @ts-ignore
  private subscription: Subscription;
  // @ts-ignore
  @Input() contract: ICtoContract;
  // @ts-ignore
  @Input() componentTitle: string;

  @Output() contractUpdated = new EventEmitter<void>();

  dropdownItems: PageHeaderDropdownItem[] = [];

  constructor(
    private ctoApiService: CtoApiService,
    private modalService: ModalService,
    private router: Router,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('contract' in changes) {
      this.dropdownItems = [
        {
          action: () => {
            this.router.navigate(['main/cto/edit/', this.contract.id]);
          },
          icon: 'edit',
          title: 'cto.edit.permissions',
          visibilityCondition: this.contract.status === 2,
        },
        {
          action: () => {
            this.openDialog();
          },
          icon: 'block',
          title: (() => {
            if (this.contract?.status === 1) return 'cto.withdraw.request';
            if (this.contract?.status === 2) return 'cto.stop.showing.data';
            return '';
          })(),
          visibilityCondition: [1, 2].includes(this.contract.status),
        },
      ];
    }
  }

  private openDialog(): void {
    let dialogButtonText = '';
    let dialogTitle = '';

    if (this.contract?.status === 1) {
      dialogButtonText = 'button.withdraw';
      dialogTitle = 'cto.withdraw.request';
    } else if (this.contract?.status === 2) {
      dialogButtonText = 'button.stop';
      dialogTitle = 'cto.stop.showing.data';
    }

    this.modalService.openOld(DialogComponent, {
      dialogText: 'cto.dialog.stop.text',
      action: this.terminateContract,
      buttonText: dialogButtonText,
      title: dialogTitle,
    });
  }

  private terminateContract = (): void => {
    this.subscription = this.ctoApiService.terminateContract(this.contract.contractId).subscribe(
      () => {
        this.contractUpdated.emit();
      },
    );
  };

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
